// document.addEventListener("DOMContentLoaded", function(){

// document.querySelectorAll(".vape-section").forEach(function(section){

// const carousel = section.querySelector(".vape-carousel");
// const leftBtn = section.querySelector(".carousel-arrow.left");
// const rightBtn = section.querySelector(".carousel-arrow.right");

// leftBtn.onclick = function(){
// carousel.scrollBy({left:-260,behavior:"smooth"});
// }

// rightBtn.onclick = function(){
// carousel.scrollBy({left:260,behavior:"smooth"});
// }

// });

// });

document.addEventListener("DOMContentLoaded", function(){

  document.querySelectorAll(".vape-section").forEach(function(section){

    const carousel = section.querySelector(".vape-carousel");
    const leftBtn = section.querySelector(".carousel-arrow.left");
    const rightBtn = section.querySelector(".carousel-arrow.right");

    let scrollTimeout;

    leftBtn.onclick = function(){
      carousel.scrollBy({left:-260, behavior:"smooth"});
    }

    rightBtn.onclick = function(){
      carousel.scrollBy({left:260, behavior:"smooth"});
    }

    function showArrows(){
      leftBtn.classList.add("show");
      rightBtn.classList.add("show");
    }

    function hideArrows(){
      leftBtn.classList.remove("show");
      rightBtn.classList.remove("show");
    }

    function updateArrowState(){
      const maxScroll = carousel.scrollWidth - carousel.clientWidth;


      if(carousel.scrollLeft <= 5){
        leftBtn.style.display = "none";
      } else {
        leftBtn.style.display = "flex";
      }

      if(carousel.scrollLeft >= maxScroll - 5){
        rightBtn.style.display = "none";
      } else {
        rightBtn.style.display = "flex";
      }
    }

    carousel.addEventListener("touchstart", function(){
      showArrows();
    });

    carousel.addEventListener("scroll", function(){

      if(carousel.scrollLeft > 5){
        showArrows();
      }

      updateArrowState();

      clearTimeout(scrollTimeout);

      scrollTimeout = setTimeout(function(){

        if(carousel.scrollLeft <= 5){
          hideArrows();
        }

      }, 1200);

    });

  });

});


// Multi Price Product

document.addEventListener("DOMContentLoaded", function(){

function getBuy8Price(){

  const option = document.querySelector('.bndlr-radio-container input[value="8"]');

  if(!option) return;

  const parent = option.closest(".bndlr-radio-container");
  const price = parent.querySelector(".bndlr-discounted-price");

  if(!price) return;

  document.querySelectorAll(".buy8price").forEach(function(el){
    el.innerText = price.innerText;
  });

}

setTimeout(getBuy8Price,1500);

});

document.addEventListener("DOMContentLoaded", function() {
  const success = document.querySelector(".contact-form__success");
  if (success) {
    success.scrollIntoView({ behavior: "smooth" });
  }
});